import { DeleteResp } from '../@types/lms/api';
import { LoginReq, LoginRes, PreLoginReq } from '../@types/lms/login/login';
import { Session } from '../@types/lms/session';
import axios from '../utils/axios';
import { APPICONFIG } from './apiconfig';

class API {
  data: any;

  url: string;

  session: Session;

  public constructor() {
    this.url = '';
    this.session = {
      token: '',
      refreshToken: '',
      refreshTokenExpiryTime: '',
    };
  }

  async makeGetRequest(): Promise<any> {
    axios.defaults.headers.post.tenant = 'root';
    const headers = {
      Authorization: 'Bearer ' + this.session.token,
    };
    let res: any;
    try {
      res = await axios.get(this.url, { headers });
    } catch (e) {
      res = e;
    }
    return res;
  }

  async downLoadFile(fileurl: string, filename: string) {
    const headers = {
      Authorization: 'Bearer ' + this.session.token,
    };
    axios.get(this.url, { responseType: 'blob', headers }).then((response) => {
      console.log('download file');
      console.log(response.status);
      if (response.status === APPICONFIG.API_RESPONSE_HEADER.OK) {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.target = 'blank';
        link.href = url;
        link.setAttribute('download', filename); //or any other extension
        document.body.appendChild(link);
        link.click();
      }
    });
  }

  async makeDownloadGetRequest(): Promise<any> {
    axios.defaults.headers.post.tenant = 'root';
    const headers = {
      Authorization: 'Bearer ' + this.session.token,
    };
    let res: any;
    try {
      res = await axios.get(this.url, { headers, responseType: 'arraybuffer' });
    } catch (e) {
      res = e;
    }
    return res;
  }

  async makeLoginGetRequest(token: string): Promise<any> {
    axios.defaults.headers.post.tenant = 'root';
    const headers = {
      Authorization: 'Bearer ' + token,
    };
    let res: any;
    try {
      res = await axios.get(this.url, { headers });
    } catch (e) {
      res = e;
    }
    return res;
  }

  async makePostRequest(): Promise<any> {
    axios.defaults.headers.post.tenant = 'root';
    let res: any;
    const headers = {
      Authorization: 'Bearer ' + this.session.token,
    };
    //PROMISE
    // try{
    //     res = await axios.post(this.url,this.data).then(
    //         (response)=>{
    //             console.log('then response');
    //             console.log(response);
    //         }
    //     ).catch(
    //         (errorResponse)=>{
    //             console.log('error response');
    //             console.log(errorResponse);
    //         }
    //
    //     );
    // }catch (e) {
    //     console.log(e);
    // }

    try {
      res = await axios.post(this.url, this.data, { headers });
    } catch (e) {
      res = e;
    }
    return res;
  }

  async makePutRequest(): Promise<any> {
    axios.defaults.headers.post.tenant = 'root';
    const headers = {
      Authorization: 'Bearer ' + this.session.token,
    };
    let res: any;
    try {
      res = await axios.put(this.url, this.data, { headers });
    } catch (e) {
      res = e;
    }
    return res;
  }

  async makeDeleteRequest(): Promise<DeleteResp> {
    let response = {
      success: false,
      errorMessage: '',
    };
    const headers = {
      Authorization: 'Bearer ' + this.session.token,
    };
    axios.defaults.headers.post.tenant = 'root';
    try {
      let res = await axios.delete(this.url, { headers });
      if (res.status !== APPICONFIG.API_RESPONSE_HEADER.OK) {
        response.success = false;
        response.errorMessage = res.data.exception;
      } else {
        response.success = true;
      }
    } catch (e) {
      response.errorMessage = e;
    }
    return response;
  }

  async checkToken(): Promise<boolean> {
    this.url = APPICONFIG.API_URL + APPICONFIG.API_PATHS.TOKENS.VALIDATE;
    let session = this.getSessionFromLocal();
    if (session.token.length === 0) {
      return false;
    }
    this.data = JSON.stringify({ token: session.token });
    console.log({ token: session.token });
    let dataResponse = await this.makePostRequest();
    if (dataResponse.status !== APPICONFIG.API_RESPONSE_HEADER.OK) {
      return false;
    }
    return true;
  }

  async checkTokenValid(token: string): Promise<boolean> {
    this.url = APPICONFIG.API_URL + APPICONFIG.API_PATHS.TOKENS.VALIDATE;
    this.data = { token: token };
    let dataResponse = await this.makePostRequest();
    if (dataResponse.status !== APPICONFIG.API_RESPONSE_HEADER.OK) {
      return false;
    } else {
      return dataResponse.data.isValid;
    }
  }

  async preLogin(loginParams: PreLoginReq): Promise<LoginRes> {
    let response: LoginRes = {
      success: false,
      token: '',
      refreshToken: '',
      refreshTokenExpiryTime: '',
      errorMessage: '',
    };
    this.data = loginParams;
    this.url = APPICONFIG.API_URL + APPICONFIG.API_PATHS.TOKENS.CREATE;
    let dataResponse = await this.makePostRequest();
    if (dataResponse.status !== APPICONFIG.API_RESPONSE_HEADER.OK) {
      response.success = false;
      response.errorMessage = dataResponse.exception;
    } else {
      response.success = true;
      response.token = dataResponse.data.token;
      response.refreshToken = dataResponse.data.refreshToken;
      response.refreshTokenExpiryTime = dataResponse.data.refreshTokenExpiryTime;
    }
    // if (response.success){
    //     let session:Session={
    //         token : response.token,
    //         refreshToken:response.refreshToken,
    //         refreshTokenExpiryTime:response.refreshTokenExpiryTime
    //     }
    //    let saveLocal= this.setToLocalSession(session);
    //     if(!saveLocal){
    //         response.success=false;
    //         response.errorMessage="Can not init localstorage";
    //     }
    // }

    return response;
  }

  async login(loginParams: LoginReq): Promise<LoginRes> {
    let response: LoginRes = {
      success: false,
      token: '',
      refreshToken: '',
      refreshTokenExpiryTime: '',
      errorMessage: '',
    };
    this.data = loginParams;
    this.url = APPICONFIG.API_URL + APPICONFIG.API_PATHS.TOKENS.REFRESH;
    let dataResponse = await this.makePostRequest();
    if (dataResponse.status !== APPICONFIG.API_RESPONSE_HEADER.OK) {
      response.success = false;
      response.errorMessage = dataResponse.exception;
    } else {
      response.success = true;
      response.token = dataResponse.data.token;
      response.refreshToken = dataResponse.data.refreshToken;
      response.refreshTokenExpiryTime = dataResponse.data.refreshTokenExpiryTime;
    }
    if (response.success) {
      let session: Session = {
        token: response.token,
        refreshToken: response.refreshToken,
        refreshTokenExpiryTime: response.refreshTokenExpiryTime,
      };
      let saveLocal = this.setToLocalSession(session);
      if (!saveLocal) {
        response.success = false;
        response.errorMessage = 'Can not init localstorage';
      }
    }

    return response;
  }

  async changeRole(roleName: string): Promise<LoginRes> {
    let response: LoginRes = {
      success: false,
      token: '',
      refreshToken: '',
      refreshTokenExpiryTime: '',
      errorMessage: '',
    };
    let session = this.getSessionFromLocal();
    this.data = {
      tenant: 'root',
      token: session.token,
      refreshToken: session.refreshToken,
      roleName: roleName,
    };
    this.url = APPICONFIG.API_URL + APPICONFIG.API_PATHS.TOKENS.REFRESH;
    let dataResponse = await this.makePostRequest();
    if (dataResponse.status !== APPICONFIG.API_RESPONSE_HEADER.OK) {
      response.success = false;
      response.errorMessage = dataResponse.exception;
    } else {
      response.success = true;
      response.token = dataResponse.data.token;
      response.refreshToken = dataResponse.data.refreshToken;
      response.refreshTokenExpiryTime = dataResponse.data.refreshTokenExpiryTime;
    }
    if (response.success) {
      let session: Session = {
        token: response.token,
        refreshToken: response.refreshToken,
        refreshTokenExpiryTime: response.refreshTokenExpiryTime,
      };
      let saveLocal = this.setToLocalSession(session);
      if (!saveLocal) {
        response.success = false;
        response.errorMessage = 'Can not init localstorage';
      }
    }

    return response;
  }

  logout(): boolean {
    localStorage.removeItem(APPICONFIG.TOKEN_NAME);
    return true;
  }

  getSessionFromLocal(): Session {
    let st = localStorage.getItem(APPICONFIG.TOKEN_NAME);
    let session: Session = {
      token: '',
      refreshToken: '',
      refreshTokenExpiryTime: '',
    };
    if (st !== null) {
      session = JSON.parse(st);
    }
    return session;
  }

  setToLocalSession(session: Session): boolean {
    try {
      localStorage.setItem(APPICONFIG.TOKEN_NAME, JSON.stringify(session));
      return true;
    } catch (e) {
      console.log('setToLocalSession error:' + e);
      return false;
    }
  }

  clearLocalSession(): boolean {
    try {
      localStorage.removeItem(APPICONFIG.TOKEN_NAME);
      return true;
    } catch (e) {
      console.log('clearLocalSession error:' + e);
      return false;
    }
  }

  init(): void {
    this.session = this.getSessionFromLocal();
  }
}

export default API;
